export const APP_CONFIG = {
  branding: 'Studio CMS',
};
